import React from "react"
import { useLocation } from "react-router-dom"
import Messages from "./Messages"
import DeletedMessages from "./DeletedMessages"

const MessagesRouter: React.FC = () => {
  const location = useLocation()

  // Determine which component to render based on the route
  if (location.pathname.endsWith("/deleted")) {
    return <DeletedMessages />
  }
  
  // Default to regular Messages for /admin/messages
  return <Messages />
}

export default MessagesRouter